<template>
  <div
    class="box"
    :class="`box--${type}`"
  >
    <LoadingBox/>
  </div>
</template>

<script>
import LoadingBox from '@/components/layout/LoadingBox'

export default {
  components: {
    LoadingBox,
  },

  props: {
    type: { type: String, default: null }
  }
}
</script>


<style lang="scss" scoped>
  .box {
    position: relative;

    &:not(&--mini) { height: 600px }

    &--mini {
      height: 6.25rem;
    }
  }
</style>